import React from 'react';
import styles from '../../styles/countryadmissionsday.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
interface Props {
  aboutdata: any;
}

const AboutQut: React.FC<Props> = ({ aboutdata }) => {
  return (
    <>
      <div
        className={styles.studentSpecialOffer}
        style={{ backgroundColor: aboutdata?.sectionBgColor || '#FFDCD8' }}
      >
        <Container>
          <Row>
            <Col xl={5} lg={5} md={5} sm={12}>
              <div className={styles.stuImg}>
                <CustomImage
                  src={aboutdata?.sectionImage ||
                    '/images/admissionsday/about-qut.svg'
                  }
                  width={207}
                  height={207}
                  className={styles.cardImg}
                  layout='responsive'
                  alt='University-Representative.png'
                />
              </div>
            </Col>
            <Col xl={7} lg={7} md={7} sm={12}>
              <div className={styles.headingabout}>
                <h2>{aboutdata.sectionTitle}</h2>
              </div>
              <div className={styles.OffersContent}>
                <div className={styles.OffersContent}>
                  {aboutdata?.offers?.length > 0 &&
                    aboutdata.offers.map((offerabt: string, ind: number) => {
                      return <p key={ind}>{offerabt}</p>;
                    })}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default AboutQut;
